import { QueryEntity } from '@datorama/akita';
import { NotificationsState, NotificationsStore } from './notifications.store';
import { Injectable } from '@angular/core';
import { MentionsState, MentionsStore } from './mentions.store';

@Injectable({
  providedIn: 'root'
})
export class MentionsQuery extends QueryEntity<MentionsState> {
  totalUnread = this.select(state => state.ui.totalUnread);
  total = this.select(state => state.ui.total);

  constructor(protected store: MentionsStore) {
    super(store);
  }
}
